import React from 'react';
import { CustomModal } from '../../components/ui/CustomModal';
import { formatCurrency, formatDateForDisplay, calculateOrderProfit, calculateItemCost } from '../../utils/helpers';

export const OrderDetailModal = ({ isOpen, onClose, order }) => {
    if (!order) return null;
    const orderSubtotal = order.items.reduce((sum, item) => sum + item.quantity * item.price, 0);
    const totalCost = order.items.reduce((sum, item) => sum + calculateItemCost(item) * item.quantity, 0);
    const totalAmount = orderSubtotal + (order.shippingFee || 0) - (order.promotion || 0);
    const { profit, percentage } = calculateOrderProfit(order);

    return (
        <CustomModal isOpen={isOpen} onClose={onClose} title={`Chi tiết Đơn hàng: ${order.id}`} maxWidth="max-w-3xl">
            <div className="space-y-6 text-gray-700">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 p-4 bg-gray-50 rounded-lg">
                    <div><strong>Khách hàng:</strong> {order.customerName}</div>
                    <div><strong>Số điện thoại:</strong> {order.phone}</div>
                    <div><strong>Ngày đặt:</strong> {formatDateForDisplay(order.date)}</div>
                    <div><strong>Nguồn đơn:</strong> {order.source}</div>
                    <div><strong>Nhãn:</strong> {order.label}</div>
                    <div><strong>Trạng thái:</strong> {order.status}</div>
                    <div className="md:col-span-2"><strong>Kho đóng gói:</strong> {order.packingWarehouse}</div>
                </div>

                <div>
                    <h4 className="text-lg font-semibold mb-2">Sản phẩm</h4>
                    <div className="border rounded-lg overflow-hidden">
                        <table className="w-full">
                            <thead className="bg-gray-100 text-left text-sm">
                                <tr>
                                    <th className="p-2">Tên sản phẩm</th>
                                    <th className="p-2 text-center">Số lượng</th>
                                    <th className="p-2 text-right">Đơn giá</th>
                                    <th className="p-2 text-right">Thành tiền</th>
                                </tr>
                            </thead>
                            <tbody>
                                {order.items.map((item, index) => (
                                    <tr key={index} className="border-t">
                                        <td className="p-2">{item.productName}</td>
                                        <td className="p-2 text-center">{item.quantity}</td>
                                        <td className="p-2 text-right">{formatCurrency(item.price)}</td>
                                        <td className="p-2 text-right">{formatCurrency(item.price * item.quantity)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                 <div className="grid grid-cols-2 gap-x-8 gap-y-1 border-t pt-4 text-sm">
                    <div className="text-right text-gray-600">Tổng tiền hàng:</div>
                    <div className="font-semibold text-right">{formatCurrency(orderSubtotal)}</div>
                    <div className="text-right text-gray-600">Tổng giá vốn:</div>
                    <div className="font-semibold text-right">{formatCurrency(totalCost)}</div>
                     <div className="text-right text-gray-600">Phí ship báo khách:</div>
                    <div className="text-right">{formatCurrency(order.shippingFee)}</div>
                     <div className="text-right text-gray-600">Phí ship thực trả:</div>
                    <div className="text-right text-red-600">-{formatCurrency(order.realShippingFee)}</div>
                     <div className="text-right text-gray-600">Khuyến mãi:</div>
                    <div className="text-right text-red-600">-{formatCurrency(order.promotion)}</div>
                     <div className="text-right text-gray-600">Phí sàn TMĐT:</div>
                    <div className="text-right text-red-600">-{formatCurrency(order.platformFee)}</div>
                    <div className="text-right text-gray-800 font-bold border-t mt-2 pt-2">Tổng tiền khách trả:</div>
                    <div className="font-bold text-right border-t mt-2 pt-2">{formatCurrency(totalAmount)}</div>

                     {profit !== null && (
                        <>
                            <div className={`text-right font-bold border-t mt-2 pt-2 ${profit >= 0 ? 'text-green-700' : 'text-red-700'}`}>Lợi nhuận đơn hàng:</div>
                            <div className={`font-bold text-right border-t mt-2 pt-2 ${profit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                {formatCurrency(profit)} ({percentage.toFixed(1)}%)
                            </div>
                        </>
                     )}
                </div>

                <div className="flex justify-end pt-4">
                    <button onClick={onClose} className="py-2 px-6 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Đóng</button>
                </div>
            </div>
        </CustomModal>
    );
};